/* Magic Flying Ball — small, self-contained interactions for mf-* sections.
   Own element names only; does not touch Shrine's product-form / cart contracts. */
(function () {
  if (window.__mfLoaded) return;
  window.__mfLoaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onVisible(el, cb, threshold) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { cb(); io.disconnect(); } });
    }, { threshold: threshold || 0.35 });
    io.observe(el);
  }

  /* Hero: tap the ball to throw it — it loops and comes back */
  if (!customElements.get('mf-throw')) customElements.define('mf-throw', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.btn = this.querySelector('[data-mf-orb]');
      if (!this.btn) return;
      this.btn.addEventListener('click', function () { self.fly(); });
      if (!reduce) onVisible(this, function () { setTimeout(function () { self.fly(); }, 900); }, 0.5);
    }
    fly() {
      if (this.classList.contains('is-flying')) return;
      var self = this;
      this.classList.remove('has-landed');
      this.classList.add('is-flying');
      setTimeout(function () { self.classList.remove('is-flying'); self.classList.add('has-landed'); }, 2700);
    }
  });

  /* Tabs */
  if (!customElements.get('mf-tabs')) customElements.define('mf-tabs', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-mf-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-mf-panel]'));
      this.tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + self.tabs.length) % self.tabs.length;
            self.select(n); self.tabs[n].focus();
          }
        });
      });
    }
    select(i) {
      this.tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      this.panels.forEach(function (p, j) { p.hidden = j !== i; });
    }
  });

  /* Horizontal slider with arrows; wraps around at both ends */
  if (!customElements.get('mf-slider')) customElements.define('mf-slider', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-mf-track]');
      if (!this.track) return;
      this.querySelectorAll('[data-mf-prev]').forEach(function (b) { b.addEventListener('click', function () { self.go(-1); }); });
      this.querySelectorAll('[data-mf-next]').forEach(function (b) { b.addEventListener('click', function () { self.go(1); }); });
    }
    step() {
      var first = this.track.children[0];
      if (!first) return this.track.clientWidth;
      var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    go(dir) {
      var t = this.track, max = t.scrollWidth - t.clientWidth - 4;
      if (dir > 0 && t.scrollLeft >= max) { t.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && t.scrollLeft <= 4) { t.scrollTo({ left: t.scrollWidth, behavior: 'smooth' }); return; }
      t.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }
  });

  /* Drag compare (screen time vs flight time) */
  if (!customElements.get('mf-compare')) customElements.define('mf-compare', class extends HTMLElement {
    connectedCallback() {
      var self = this, input = this.querySelector('input[type="range"]');
      if (!input) return;
      var set = function () { self.style.setProperty('--pos', input.value + '%'); };
      input.addEventListener('input', set); set();
    }
  });

  /* Exploded diagram pins */
  if (!customElements.get('mf-pins')) customElements.define('mf-pins', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.pins = Array.prototype.slice.call(this.querySelectorAll('[data-mf-pin]'));
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-mf-part]'));
      var act = function (i) {
        self.pins.forEach(function (p, j) { p.classList.toggle('is-active', j === i); p.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        self.items.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      };
      this.pins.forEach(function (p, i) { p.addEventListener('click', function () { act(i); var it = self.items[i]; if (it && it.scrollIntoView && window.innerWidth < 750) it.parentNode.scrollTo({ left: it.offsetLeft - 20, behavior: 'smooth' }); }); p.addEventListener('mouseenter', function () { act(i); }); });
      this.items.forEach(function (p, i) { p.addEventListener('mouseenter', function () { act(i); }); });
    }
  });

  /* Count-down reveal for the closing CTA */
  if (!customElements.get('mf-launch')) customElements.define('mf-launch', class extends HTMLElement {
    connectedCallback() { var self = this; onVisible(this, function () { self.classList.add('is-go'); }, 0.4); }
  });

  /* Any [data-mf-buy] link scrolls to the product buy box (Shrine ProductInfo-*) instead of navigating */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-mf-buy]');
    if (!a) return;
    var target = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product__info-wrapper');
    if (!target) return; /* no buy box on this page: follow the link */
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
